// Canal caído · datos de marca por red social (Victor 2026-05-25).
// Extiende la alerta de WhatsApp (en prod desde 2026-05-17) a Instagram,
// Facebook y TikTok con el MISMO modal glass + barra roja, mostrando logo,
// color y nombre dinámicos de la red afectada.

// Logo SVG (blanco) de cada red — se pinta sobre el color de marca.
export const NETWORK_ICON = {
  whatsapp:
    '<svg viewBox="0 0 24 24" fill="#fff"><path d="M12 2a10 10 0 00-8.6 15l-1.3 4.7 4.8-1.3A10 10 0 1012 2zm0 18a8 8 0 01-4.1-1.1l-.3-.2-2.8.8.7-2.8-.2-.3A8 8 0 1112 20zm4.4-5.9c-.2-.1-1.4-.7-1.6-.8s-.4-.1-.5.1-.6.8-.8 1-.3.2-.5 0a6.5 6.5 0 01-1.9-1.2 7.2 7.2 0 01-1.3-1.7c-.1-.2 0-.4.1-.5l.4-.4.2-.4v-.4l-.8-1.8c-.2-.5-.4-.4-.5-.5h-.5a1 1 0 00-.7.3 2.8 2.8 0 00-.9 2.1A4.9 4.9 0 009 11.4a11 11 0 004.2 3.7c.6.2 1 .4 1.4.3.4-.1 1.4-.6 1.6-1.1s.2-1 .1-1.1l-.5-.2z"/></svg>',
  instagram:
    '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1.2" fill="#fff" stroke="none"/></svg>',
  facebook:
    '<svg viewBox="0 0 24 24" fill="#fff"><path d="M12 2C6.3 2 2 6.2 2 11.6c0 2.9 1.3 5.5 3.4 7.2v3.6l3.1-1.7c.8.2 1.7.4 2.5.4 5.7 0 10-4.2 10-9.5S17.7 2 12 2zm1 12.3l-2.6-2.7-5 2.7 5.5-5.8 2.6 2.7 4.9-2.7-5.4 5.8z"/></svg>',
  tiktok:
    '<svg viewBox="0 0 24 24" fill="#fff"><path d="M16.5 2c.3 2.2 1.6 3.9 3.8 4.1v2.6c-1.3.1-2.5-.3-3.8-.9v6.3c0 3.5-2.6 6-5.9 6a5.7 5.7 0 01-5.8-5.7c0-3.4 3-5.9 6.4-5.5v2.7c-.5-.1-1-.2-1.4-.2-1.6 0-2.8 1.2-2.8 2.8s1.2 2.8 2.7 2.8c1.6 0 2.9-1.2 2.9-3.1V2h3.9z"/></svg>',
  generic:
    '<svg viewBox="0 0 24 24" fill="#fff"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 15h-2v-2h2zm0-4h-2V7h2z"/></svg>',
};

// Marca por red: nombre visible + color/gradiente + glow.
export const NETWORK_BRAND = {
  whatsapp: { label: 'WhatsApp', color: 'linear-gradient(135deg,#25d366,#128c4b)', glow: '#25d366' },
  instagram: { label: 'Instagram', color: 'linear-gradient(135deg,#f09433,#dc2743 45%,#bc1888)', glow: '#dc2743' },
  facebook: { label: 'Facebook', color: 'linear-gradient(135deg,#1877f2,#0a52c4)', glow: '#1877f2' },
  tiktok: { label: 'TikTok', color: 'linear-gradient(135deg,#25F4EE,#000 45%,#FE2C55)', glow: '#FE2C55' },
  generic: { label: 'Canal', color: 'linear-gradient(135deg,#888,#444)', glow: '#888' },
};

// Detecta la red de un inbox. TikTok de Victor es Channel::Api (bridge propio),
// se distingue por el nombre del inbox.
export function detectNetwork(inbox) {
  const type = inbox?.channel_type;
  const name = (inbox?.name || '').toLowerCase();
  if (type === 'Channel::Instagram') return 'instagram';
  if (type === 'Channel::FacebookPage') return 'facebook';
  if (type === 'Channel::Tiktok') return 'tiktok';
  if (type === 'Channel::Api' && name.includes('tiktok')) return 'tiktok';
  if (type === 'Channel::Whatsapp' || type === 'Channel::Api') return 'whatsapp';
  return 'generic';
}

// ¿El canal de esta conversación está caído? Dos fuentes:
//  - WAHA/Bridge/TikTok → conn_status='disconnected' (job health-check)
//  - Instagram/Facebook → Meta revocó el token (reauthorization_required)
export function isChannelDown(currentChat, inbox) {
  if (currentChat?.inbox_conn_status === 'disconnected') return true;
  const net = detectNetwork(inbox);
  if ((net === 'instagram' || net === 'facebook') && inbox?.reauthorization_required) {
    return true;
  }
  return false;
}

// Datos de marca listos para el modal/barra de un inbox.
export function networkBrand(inbox) {
  const net = detectNetwork(inbox);
  return { net, icon: NETWORK_ICON[net], ...NETWORK_BRAND[net] };
}
